import { useState, useEffect } from "react";
import Cookies from "js-cookie";
import axios from "../../axios.jsx";
import BOSForm from "../../components/BOSForm";
import { logout } from "../../Helpers";
import { useLocation } from "react-router-dom";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import Done from "../../Images/right.png";


function BOSPanelPrint() {
    
    const [panelData, setPanelData] = useState(null);

    const loc = useLocation();
    function removeNavbar() {
        document.getElementsByClassName("navbar")[0].style.display = "none";
      }
    useEffect(() => {
        if (Cookies.get("username") !== "acoe") {
            alert("unauthorized to this page")
            logout("/bospanel-login");
            return;
        }
        fetchData();
        removeNavbar();
    }, []);
    async function fetchData() {
        try {
            let form_data = new FormData();
            form_data.append("scholar_id", loc.state.id);
            const resData = await axios.post("/api/get-bospanel", form_data);
            if (resData.status === 200) {
                setPanelData(resData.data);
                console.log(panelData, resData.data)
            }
            else if (resData.status === 403) {
                alert(resData.Message);
                logout("/officers-login");
                return;
            }
        } catch (e) {
            if (e.code === "ERR_BAD_REQUEST") {
                logout("/officers-login");
                return;
            }
        }
    }

    const printyo = () => {
        window.print();
      };
      
    return(
        <>
        {(panelData === null ) ? (
            <center>
              <RotateLeftIcon
                sx={{
                  fontSize: "3rem",
                  margin: "0 auto",
                  color: "rgba(0,0,0,0.6)",
                  animation: "spin 1s linear infinite",
                  "@keyframes spin": {
                    "0%": {
                      transform: "rotate(360deg)",
                    },
                    "100%": {
                      transform: "rotate(0deg)",
                    },
                  },
                }}
              />{" "}
              Loading Details
            </center>
          ) : (
              <div className="whole">
            <br /><br />
            <center>
                <form className="form-a">
                    <br />
                    <p style={{ "fontSize": "28px", "textDecoration": "underline" }}>Panel of Adjuticators</p><br />
                    <div className="date-field">
                        Date : <input value={panelData.panel_data.date} className="adj-input" type="date" disabled={true} />
                    </div ><br />
                    <div className="form-header">
                        To<br />
                        The COE,<br />
                        Kakatiya University,<br />
                        Warangal.<br /><br />
                        <table className="scholar-details-table">
                            <tr>
                                <td >
                                    Scholar ID
                                </td >
                                <td > <input className="adj-input" value={panelData.panel_data.scholar_id} type="text" disabled={true} />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Name of the Scholar
                                </td >
                                <td > <input className="adj-input" value={panelData.panel_data.name_of_scholar} type="text" disabled={true} />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Subject
                                </td >
                                <td > <input className="adj-input" value={panelData.panel_data.subject} type="text" disabled="true" />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Title
                                </td >
                                <td > <input className="adj-input" value={panelData.panel_data.title} type="text" disabled={true} />
                                </td>
                            </tr>
                            <tr>
                                <td >
                                    Name of the Supervisor
                                </td >
                                <td > <input className="adj-input" value={panelData.panel_data.name_of_supervisor} type="text" disabled={true} />
                                </td>
                            </tr>
                        </table>
                        <br />
                    </div>
                    <center>
                        <table className="adjuticators-table">
                            <tr>
                                <th width="3%">Sno.</th>
                                <th width="17%">Name of the Adjuticator</th>
                                <th width="13%">Department</th>
                                <th width="17%">Name of University and Address</th>
                                <th width="14%">State</th>
                                <th width="13%">Mobile No.</th>
                                <th width="13%">E-mail</th>
                            </tr>
                            {panelData.adjuticators_data.map((adjuticator,i) =>
                                <tr key={i}>
                                    <th>{adjuticator.id}.</th>
                                    <td><input className="adj-input" disabled={true} value={adjuticator.name}></input></td>
                                    <td><input className="adj-input" disabled={true} value={adjuticator.department}></input></td>
                                    <td><input className="adj-input" disabled={true} value={adjuticator.name_of_university}></input></td>
                                    <td><input className="adj-input" disabled={true} value={adjuticator.state}></input></td>
                                    <td><input className="adj-input" type="number" max="9999999999" disabled={true} value={adjuticator.mobile}></input></td>
                                    <td><input type="email" className="email-input adj-input" disabled={true} value={adjuticator.email}></input></td>
                                </tr>
                            )}
                        </table>
                    </center>
                    <br />
                    <div className="note-view">
                        <b>Note:</b>
                        <ul>
                            <li>Adjudicator must not below Associate Professor Rank.</li>
                            <li>More than one Adjudicator is not allowed from same University/Institute.</li>
                            <li>The above Panel of Adjuticators have been Approved by Board Of Studies.</li>
                            <li>Fill the Adjudicators as following 1-3 from Telangana State and 4-9 from Other States.</li>
                        </ul>
                    </div>
                    <br />
                    <div className="bos-signature">

                        <table >
                            <tr>
                                <td width="40%">
                                    Signature
                                </td>
                                <td>
                                            
                                            <img src={axios.defaults.baseURL + "api" + panelData.panel_data.signature_of_BOS}/>
                                       


                                </td>
                            </tr>
                            <tr>
                                <td> Name of the Chairperson BOS
                                </td>
                                <td>
                                    : <input className="adj-input" value={panelData.panel_data.name_of_BOS} type="text" disabled={true} />
                                </td>
                            </tr>
                        </table>
                    </div>
                    <br />
                    <br />
                    <br />
                </form>
                <br />
            </center>
        </div>)}
        <div class="tenth">
          <button id="print" onClick={printyo}>
            Print
          </button>
        </div>
        </>
    )
}

export default BOSPanelPrint;

